import React from 'react'
import ReactDom from 'react-dom'
import 'videojs-disable-progress-bar'
import { formatQuestionText } from 'shared/helpers/question'

export default class QuestionText extends React.Component {
  render () {
    return (
      <div>{this.props.questionText}</div>
    )
  }
}
